import { useClientPortalAPI } from "@certn/api";

import { useQueryParams } from "../../../hooks/useQueryParams";
import { queryParamsToApiParams } from "../../utils";
import { CasesTable } from "../components/CasesTable";

export function ReviewCasesTab() {
  const { params } = useQueryParams();
  const { data, isLoading, error } = useClientPortalAPI(
    "/api/internal/client-portal/case/review/",
    queryParamsToApiParams(params)
  );

  return (
    <CasesTable
      cases={data}
      isLoading={isLoading}
      error={error}
      statusSubset="review"
    />
  );
}
